// **************************************************
// Filter toggle
// **************************************************

const filterTitles = (windowWidth() > breakpointMd ? document.querySelectorAll('.shop-dropdown-filter__title:not(.shop-dropdown-filter__title--single-item)') : document.querySelectorAll('.shop-dropdown-filter__title'));
if (filterTitles) {
  filterTitles.forEach((filterTitle) => {
    const filterItem = filterTitle.closest('.shop-dropdown-filter');
    const filterContent = filterItem.querySelector('.shop-dropdown-filter__content');
    const filterOptions = filterItem.querySelectorAll('input');
    const filterOptionSelected = filterItem.querySelectorAll('.shop-dropdown-filter__selected-items');
    const filterOptionTextItems = [];

    // Change Selected Text
    if (filterOptions) {
      filterOptions.forEach((el) => {
        el.addEventListener('change', (evt) => {
          const filterOptionsParent = el.closest('.checkbox');
          const filterOptionsRadio = el.closest('.radio-button');

          // CheckBox Checked And Remove
          if (filterOptionsParent) {
            const filterOptionsText = filterOptionsParent.querySelector('.checkbox__text')

            if (el.checked) {
              filterOptionTextItems.push(filterOptionsText.innerHTML)
            } else {
              const index = filterOptionTextItems.indexOf(filterOptionsText.innerHTML);
              if (index > -1) {
                filterOptionTextItems.splice(index, 1);
              }
            }
            filterOptionSelected[0].innerHTML = filterOptionTextItems;
          }

          // Radio Button Checked
          if (filterOptionsRadio) {
            const filterOptionsRadioText = filterOptionsRadio.querySelector('.radio-button__text');
            filterOptionSelected[0].innerHTML = filterOptionsRadioText.innerHTML;
          }
        });
      });
    }

    // Remove Class In Responsive View
    if (windowWidth() < breakpointMd) {
      filterItem.classList.remove('is-open-filter');
    }

    // Toggle Class And Slide Toggle On Click
    filterTitle.addEventListener('click', () => {
      filterItem.classList.toggle('is-open-filter');

      if (windowWidth() < breakpointMd) {
        document.body.classList.toggle('is-open-filter');
      } else {
        slideToggle(filterContent, 300, 'block');
      }
    });
  });
}
